var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center flex-column user-select subtitle",class:[_vm.animation, _vm.device == 'mobile'? 'mobile' : ''],style:({
    '--color': _vm.color || '#0A64A1',
    'padding-top': _vm.padding_top,
    'padding-bottom': _vm.padding_bottom,
  })},[_c('div',{staticClass:"title"},[_c('div',{staticClass:"title-content"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]),_c('div',{staticClass:"title-en"},[_vm._v(_vm._s(_vm.title_en))])])}
var staticRenderFns = []

export { render, staticRenderFns }